import { useMutation } from '@tanstack/react-query';

import { useToastActions } from 'stores/toastStore';

type UseMutateWithToastProps = {
  mutationFn: (data: any) => Promise<any>;
  onSuccess?: (data?: any) => void;
  onError?: () => void;
  onSettled?: () => void;
};

const useMutateWithToast = ({ mutationFn, onSuccess, onError, onSettled }: UseMutateWithToastProps) => {
  const { addToast } = useToastActions();

  const { mutate, mutateAsync, isPending } = useMutation({
    mutationFn,
    onSuccess,
    onError: () => {
      addToast({ text: 'Something went wrong. Please try again' });
      onError?.();
    },

    onSettled: () => {
      onSettled?.();
    },
  });

  // `mutateAsync` alongside `mutate` for callers that must SEQUENCE writes — awaiting one before
  // starting the next. It rejects on failure, so an awaiting caller has to catch; the toast is
  // raised either way.
  return { mutate, mutateAsync, isPending };
};

export default useMutateWithToast;
